export interface INotFoundViewInteractor {}

export const useNotFoundViewInteractor = (): INotFoundViewInteractor => {
  return {}
}
